import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { makeOptionsFromPropertyWithoutBlankOptions, makeOptionsFromProperty } from 'customer-data-property-utils/PropertyValueDisplay';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import UISelect from 'UIComponents/input/UISelect';
import { isMultienum } from 'customer-data-objects/property/PropertyIdentifier';
import PropertyPropType from '../utils/propTypes/PropertyPropType';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import refObject from 'UIComponents/utils/propTypes/refObject';
import { jsx as _jsx } from "react/jsx-runtime";
export default class PropertyInputEnum extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleChange = ({
      target: {
        value
      }
    }) => {
      const {
        onChange
      } = this.props;
      onChange(SyntheticEvent(Array.isArray(value) ? value.join(';') : value));
    };
  }
  // Unfortunately `<UISelect multi={true}>` does not highlight values
  // which are invalid (values which do not match an option). Single
  // selects show a red border when their value is invalid, but multi
  // selects have no feedback.
  //
  // The BE prevents invalid values from being set on enumerations,
  // but does not block subsequent changes to the property definition
  // which remove in-use options.
  //
  // When we removed the red highlight, we immediately got JIRAs from
  // users who were confused why they couldn't save changes to some
  // properties (because they had invalid values).
  //
  // #hds-support confirmed that the best solution currently is to
  // manually detect invalid options and create temporary options
  // that give them a highlight color.
  //
  // See https://git.hubteam.com/HubSpot/UIComponents/issues/9868
  // See https://product.hubteam.com/docs/crm-properties/values/enumeration.html
  getOptionsWithInvalidPlaceholders(values, options) {
    const {
      property
    } = this.props;
    if (values.length) {
      const validValues = property.options.reduce((acc, option) => {
        acc.add(option.value);
        return acc;
      }, new Set());
      const invalidValues = values.filter(val => !validValues.has(val));
      if (invalidValues.length) {
        return [...(options || []), ...invalidValues.map(val => {
          return {
            text: val || '',
            value: val || undefined,
            tagUse: 'candy-apple'
          };
        })];
      }
    }
    return options;
  }
  render() {
    const multi = isMultienum(this.props.property);
    const value = multi ? parseMultiEnumValue(this.props.value) : this.props.value;

    // Add a placeholder option for optional single selects if one is not already present.
    // Multi selects don't need a placeholder (they can be cleared manually).
    // Required selects don't need a placeholder option (user must pick a real option).
    let options = (multi || this.props.isRequired) && !this.props.emptyOptionLabel ? makeOptionsFromPropertyWithoutBlankOptions(this.props.property) : makeOptionsFromProperty(this.props.property);
    if (this.props.emptyOptionLabel) {
      options = options.map(option => option.value === '' ? Object.assign({}, option, {
        text: this.props.emptyOptionLabel
      }) : option);
    }
    return /*#__PURE__*/_jsx(UISelect, Object.assign({}, getTransferrableProps(this.props, ['onFocus', 'onKeyUp']), {
      onChange: this.handleChange,
      multi: multi,
      anchorType: "button",
      options: multi ? this.getOptionsWithInvalidPlaceholders(value, options) : options,
      placeholder: this.props.placeholder == null ? '' : this.props.placeholder,
      ref: this.props.inputRef,
      value: value
    }));
  }
}
PropertyInputEnum.propTypes = {
  inputRef: refObject.isRequired,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.node,
  property: PropertyPropType.isRequired,
  value: PropTypes.node
};